import { render } from "./TeacherHome.vue?vue&type=template&id=0b8f0ac8&scoped=true"
import script from "./TeacherHome.vue?vue&type=script&lang=js"
export * from "./TeacherHome.vue?vue&type=script&lang=js"

import "./TeacherHome.vue?vue&type=style&index=0&id=0b8f0ac8&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8f0ac8"]])

export default __exports__